import {mapAllReactionsToDomain} from '../../mappers/reactions/reactions-mapper';
import {articleReactionsHttpRepository} from '../../repositories/article-reactions-http-repository';
import {articleReactionMemoryRepository} from '../../repositories/article-reactions-memory-repositiory';

export const readArticlReactions = articleId => articleReactionsHttpRepository
  .getAllReactions(articleId)
  .then(reactions =>
    articleReactionMemoryRepository.setCommonReactions(articleId, mapAllReactionsToDomain(articleId, reactions))
  )
  .catch(console.error);

